export default "__VITE_ASSET__DBg3ypes__"